/* M'OUD Concierge im Shop (v8, 22.10.2026, Entwurf). Oeffnet sich nur auf Klick
   (Kodex 3.3). Spricht mit websiteConcierge (Base44), derselbe Agent wie auf
   WhatsApp und Instagram. Kein Popup, kein Auto-Open, keine Cookies; die
   Sitzungs-ID liegt nur in sessionStorage. */
(function () {
  var w = window, d = document, C = w.MOUD || {}, API = C.api || '';
  var L = C.lang === 'en' ? 'en' : 'de';
  var T = {
    de: { title: 'Concierge', sub: 'Ali und Maya lesen mit und übernehmen jederzeit.', ph: 'Ihre Frage …', send: 'Senden', wa: 'Lieber persönlich auf WhatsApp', open: 'Ansehen', hello: 'Guten Tag, hier antwortet der digitale Concierge von M’OUD. Für welchen Moment suchen Sie einen Duft?', err: 'Etwas hat nicht funktioniert. Bitte schreiben Sie uns auf WhatsApp.', close: 'Schliessen' },
    en: { title: 'Concierge', sub: 'Ali and Maya read along and take over at any time.', ph: 'Your question …', send: 'Send', wa: 'Rather personally on WhatsApp', open: 'View', hello: 'Hello, this is M’OUD’s digital concierge. Which moment are you choosing a scent for?', err: 'Something did not work. Please write to us on WhatsApp.', close: 'Close' }
  }[L];
  var WA = 'https://wa.me/41799044425';
  var sid;
  try { sid = sessionStorage.getItem('moud_cs'); } catch (e) {}
  if (!sid) { sid = 'w' + Date.now().toString(36) + Math.random().toString(36).slice(2, 8); try { sessionStorage.setItem('moud_cs', sid); } catch (e) {} }

  var box, log, inp, busy = false;
  function el(t, c, txt) { var e = d.createElement(t); if (c) e.className = c; if (txt) e.textContent = txt; return e; }
  function build() {
    box = el('div', 'cs'); box.setAttribute('role', 'dialog'); box.setAttribute('aria-label', T.title); box.hidden = true;
    var hd = el('div', 'cs-hd');
    var tt = el('div'); tt.appendChild(el('span', 'eye', T.title)); tt.appendChild(el('p', 'cs-sub', T.sub));
    var x = el('button', 'cs-x', '×'); x.type = 'button'; x.setAttribute('aria-label', T.close); x.onclick = close;
    hd.appendChild(tt); hd.appendChild(x);
    log = el('div', 'cs-log'); log.setAttribute('aria-live', 'polite');
    var f = el('form', 'cs-f'); inp = el('input'); inp.type = 'text'; inp.maxLength = 600; inp.placeholder = T.ph; inp.setAttribute('aria-label', T.ph);
    var b = el('button', 'btn p', T.send); b.type = 'submit';
    f.appendChild(inp); f.appendChild(b); f.onsubmit = function (e) { e.preventDefault(); send(); };
    var wa = el('a', 'cs-wa tlink', T.wa); wa.href = WA; wa.target = '_blank'; wa.rel = 'noopener'; wa.setAttribute('data-where', 'chat');
    box.appendChild(hd); box.appendChild(log); box.appendChild(f); box.appendChild(wa);
    d.body.appendChild(box);
    msg('out', T.hello);
  }
  function msg(dir, text, card) {
    var m = el('div', 'cs-m ' + dir); m.textContent = text;
    if (card && card.url) {
      var c = el('a', 'cs-card'); c.href = card.url;
      if (card.image) { var i = el('img'); i.src = card.image + '&width=160'; i.alt = ''; i.loading = 'lazy'; c.appendChild(i); }
      var s = el('span'); s.appendChild(el('b', '', card.name)); s.appendChild(el('small', '', T.open + ' →')); c.appendChild(s);
      m.appendChild(c);
    }
    log.appendChild(m); log.scrollTop = log.scrollHeight;
  }
  function open() { if (!box) build(); box.hidden = false; d.documentElement.classList.add('cson'); setTimeout(function () { inp && inp.focus(); }, 50); try { w.moudTrack && moudTrack('chat_open', location.pathname); } catch (e) {} }
  function close() { if (box) box.hidden = true; d.documentElement.classList.remove('cson'); }
  function send() {
    var t = (inp.value || '').trim(); if (!t || busy || !API) return;
    inp.value = ''; msg('in', t); busy = true;
    var dots = el('div', 'cs-m out cs-dots'); dots.innerHTML = '<i></i><i></i><i></i>'; log.appendChild(dots); log.scrollTop = log.scrollHeight;
    fetch(API + 'websiteConcierge', { method: 'POST', headers: { 'content-type': 'text/plain' }, body: JSON.stringify({ sid: sid, text: t, lang: L, cc: C.cc || '', page: location.pathname }) })
      .then(function (r) { return r.json(); })
      .then(function (j) {
        dots.remove();
        msg('out', (j && j.reply) || T.err, j && j.card);
        if (j && (j.action === 'human' || j.action === 'business' || j.action === 'whatsapp')) box.querySelector('.cs-wa').classList.add('hi');
      })
      .catch(function () { dots.remove(); msg('out', T.err); })
      .then(function () { busy = false; });
  }
  d.addEventListener('click', function (e) { var t = e.target; if (t.closest && t.closest('[data-chat]')) { e.preventDefault(); open(); } });
  d.addEventListener('keydown', function (e) { if (e.key === 'Escape' && box && !box.hidden) close(); });
})();